import {useState} from 'react';

export default function useInput(initialValue, onSelect) {
  const [value, setValue] = useState(initialValue);

  function handleChange(e) {
    setValue(e.target.value);
    onSelect(e.target.value);
  }

  return [value, handleChange, onSelect];
}
